import { unAuthenticationGuard } from "./core/services/unAuthorized.guard";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "./core/services/authentication.guard";
import { Permissions } from "./core/services/permissions";
import { InternetConnectionFailed } from "./modules/oops/components/internet-connection-failed/internet-connection-failed.component";

const routes: Routes = [
  {
    path: "login",
    canActivate: [unAuthenticationGuard],
    loadChildren: () =>
      import("./modules/authentication/authentication.module").then(
        a => a.AuthenticationModule
      ),
  },
  {
    path: "oops",
    loadChildren: () =>
      import("./modules/oops/oops.module").then(a => a.OopsModule),
  },
  {
    path: "error-internet-connection",
    component: InternetConnectionFailed,
    data: { title: "Oops!" }, // This is the page title showing in the tab (in browser)
  },
  {
    path: "dashboard",
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import("./modules/dashboard/dashboard.module").then(
        a => a.DashboardModule
      ),
  },
  {
    path: "users",
    loadChildren: () =>
      import("./modules/users/users.module").then(a => a.UsersModule),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.UserManagement.Users.view],
    },
  },
  {
    path: "process",
    loadChildren: () =>
      import("./modules/process/process.module").then(a => a.ProcessModule),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.WorkFlow.ManageProcess],
    },
  },
  {
    path: "lookups",
    loadChildren: () =>
      import("./modules/lookup-mangement/lookup-mangement.module").then(
        a => a.LookupMangementModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.UserManagement.Groups.view],
    },
  },
  {
    path: "roles",
    loadChildren: () =>
      import("./modules/roles/roles.module").then(a => a.RolesModule),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.UserManagement.Roles.view],
    },
  },

  {
    path: "settings",
    loadChildren: () =>
      import("./modules/settings/settings.module").then(a => a.SettingsModule),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.Settings.ListSettings],
    },
  },
  {
    path: "authentication-logs-dashboard",
    loadChildren: () =>
      import(
        "./modules/authentication-logs-dashboard/authentication-logs-dashboard.module"
      ).then(a => a.AuthenticationLogsDashboardModule),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.Settings.ListSettings],
    },
  },
  {
    path: "committees",
    loadChildren: () =>
      import("./modules/committee/committee.module").then(
        a => a.CommitteeModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.UserManagement.Committees.view],
    },
  },
  {
    path: "groups",
    loadChildren: () =>
      import("./modules/groups/groups.module").then(a => a.GroupsModule),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.UserManagement.Groups.view],
    },
  },
  {
    path: "loyalty",
    loadChildren: () =>
      import("./modules/loyalty/loyalty.module").then(a => a.LoyaltyModule),
    canActivate: [AuthenticationGuard],
    // data: {
    //   allowedClaims: [Permissions.UserManagement.Groups.view],
    // },
  },
  {
    path: "centers",
    loadChildren: () =>
      import("./modules/centers/center.module").then(a => a.CenterModule),
    canActivate: [AuthenticationGuard],
    // data: {
    //   allowedClaims: [Permissions.UserManagement.Groups.view],
    // },
  },
  {
    path: "nfc",
    loadChildren: () =>
      import("./modules/nfc-cards/nfc-cards.module").then(
        a => a.NfcCardsModule
      ),
    canActivate: [AuthenticationGuard],
    // data: {
    //   allowedClaims: [Permissions.UserManagement.Groups.view],
    // },
  },

  {
    path: "cms-management",
    loadChildren: () =>
      import("./modules/cms-management/cms-management.module").then(
        a => a.CmsManagementModule
      ),
    canActivate: [AuthenticationGuard],
  },
  {
    path: "content-management",
    loadChildren: () =>
      import("./modules/content-management/content-management.module").then(
        a => a.ContentManagementModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      // allowedClaims: [Permissions.ContentManagement.view],
      claims: [90000],
    },
  },
  {
    path: "media-center",
    loadChildren: () =>
      import("./modules/media-center/media-center.module").then(
        a => a.MediaCenterModule
      ),
    canActivate: [AuthenticationGuard],
    // data: {
    //   allowedClaims: [Permissions.MediaCenter.view],
    // },
  },
  {
    path: "events",
    loadChildren: () =>
      import("./modules/events/events.module").then(a => a.EventsModule),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.Events.ListEvent],
    },
  },
  {
    path: "event",
    loadChildren: () =>
      import("./modules/event-registration/event-registration.module").then(
        a => a.EventRegistrationModule
      ),
  },
  {
    path: "jobs",
    loadChildren: () =>
      import("./modules/jobs/jobs.module").then(a => a.JobsModule),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.Jobs.ListJobs],
    },
  },
  {
    path: "volunteers",
    loadChildren: () =>
      import("./modules/volunteer/volunteer.module").then(
        a => a.VolunteerModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      allowedClaims: [Permissions.Volunteers.ListVolunteers],
    },
  },
  {
    path: "membership",
    loadChildren: () =>
      import("./modules/membership/membership.module").then(
        a => a.MembershipModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      // allowedClaims: [Permissions.Membership.MembershipManagement],
    },
  },
  {
    path: "competition",
    loadChildren: () =>
      import("./modules/competition/competition.module").then(
        a => a.CompetitionModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      // allowedClaims: [Permissions.Competition.ListCompetition],
    },
  },
  {
    path: "new-competition",
    loadChildren: () =>
      import("./modules/new-competition/competition.module").then(
        a => a.CompetitionModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      // allowedClaims: [Permissions.Competition.ListCompetition],
    },
  },
  {
    path: "booking",
    loadChildren: () =>
      import("./modules/booking/booking.module").then(a => a.BookingModule),
    canActivate: [AuthenticationGuard],
    data: {
      // allowedClaims: [Permissions.Booking.ListBookingRequests],
    },
  },
  {
    path: "donations",
    loadChildren: () =>
      import("./modules/donations/donations.module").then(
        a => a.DonationsModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      // allowedClaims: [Permissions.Donations.ListDonations],
    },
  },
  {
    path: "survey",
    loadChildren: () =>
      import("./modules/survey/survey.module").then(
        a => a.SurveyModule
      ),
    canActivate: [AuthenticationGuard],
    data: {
      // allowedClaims: [Permissions.Competition.ListCompetition],
    },
  },
  {
    path: "satisfaction-sharing",
    loadChildren: () =>
      import("./modules/satisfaction-sharing/satisfaction-sharing.module").then(
        a => a.SatisfactionSharingModule
      ),
    canActivate: [AuthenticationGuard],
  },
  {
    // Public entry point for the emailed password-reset link.
    // No guard: must be reachable while unauthenticated.
    path: "forgot-password",
    loadChildren: () =>
      import("./modules/reset-password/reset-password.module").then(
        m => m.ResetPasswordModule
      ),
  },
  {
    // Public entry point for the emailed password-reset link.
    // No guard: must be reachable while unauthenticated.
    path: "reset-password",
    loadChildren: () =>
      import("./modules/reset-password/reset-password.module").then(
        m => m.ResetPasswordModule
      ),
  },
  {
    path: "",
    redirectTo: "/dashboard",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "oops/not-found",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
